<div class="multi-column-select-container" (clickOutside)="onDocumentClick()">
  <mat-form-field appearance="fill" class="custom-form-field" *ngIf="!defaultOpenState">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input 
      matInput 
      [value]="selectedLabel" 
      [placeholder]="placeholder"
      [disabled]="disabled"
      readonly
      (click)="onInputClick($event)"
      class="form-control"
    />
    <mat-icon matSuffix (click)="toggleDropdown()" class="dropdown-icon">
      {{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
    
    <mat-error *ngIf="errorMessage">
      {{ errorMessage }}
    </mat-error>
  </mat-form-field>

  <div class="dropdown-panel" [class.always-open]="defaultOpenState" *ngIf="isOpen || defaultOpenState" [style.max-height]="maxHeight" (click)="$event.stopPropagation()">
    <div class="dropdown-content">
      <div class="search-container">
        <mat-form-field appearance="outline" class="search-field">
          <input 
            matInput 
            [value]="searchText"
            (input)="onSearchInput($event)"
            [placeholder]="'TypeToSearch' | translate"
            class="search-input"
          />
          <!-- <mat-icon matSuffix class="search-icon">search</mat-icon> -->
          <!-- <button 
            *ngIf="searchText" 
            matSuffix 
            mat-icon-button 
            (click)="clearSearch()"
            class="clear-search-btn"
            type="button">
            <mat-icon>close</mat-icon>
          </button> -->
        </mat-form-field>
      </div>

      <!-- Options in Columns -->
      <div class="columns-container" [style.grid-template-columns]="'repeat(' + columns + ', 1fr)'">
        <div class="column" *ngFor="let column of filteredOptionsForColumns; let columnIndex = index">
          <div 
            class="option-item" 
            *ngFor="let option of column"
            [class.selected]="isOptionSelected(option)"
            (mousedown)="selectOption(option, $event)"
            [title]="isTextTruncated(option[selectionConfig.label]) ? option[selectionConfig.label] : ''"
          >
            <img
              *ngIf="imageKey"
              class="option-thumb"
              [src]="option[imageField] || fallbackImage"
              (error)="onImageError($event)"
              alt="" />
            <span class="option-texts">{{ option[selectionConfig.label] }}</span>
            <!-- Multi-select indicator -->
            <span *ngIf="selectionMode === 'multiple'" class="multi-select-indicator">
              <mat-icon *ngIf="isOptionSelected(option)" class="check-icon">check</mat-icon>
            </span>
          </div>
        </div>
      </div>

      <!-- No Results Message -->
      <div *ngIf="searchText && filteredOptions.length === 0" class="no-results">
        <p>{{ 'NoOptionsFoundMatching' | translate }} "{{ searchText }}"</p>
      </div>
    </div>
  </div>
</div> 